import React from "react";
import { useLandingLang } from "../../i18n/LandingLangContext";

export function Footer({ logoSrc, onScrollToId }) {
  const { t } = useLandingLang();
  const handleScrollTop = () => {
    if (typeof onScrollToId === "function") {
      onScrollToId("top");
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  // Función auxiliar para bloquear enlaces vacíos y evitar recarga
  const handleDeadLink = (e) => {
    e.preventDefault();
  };

  return (
    <footer className="py-20 px-6 bg-slate-50 border-t border-slate-200 text-center md:text-left text-slate-500">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-start gap-12">
        {/* COLUMNA IZQUIERDA: Logo y Eslogan */}
        <div className="space-y-6 max-w-xs mx-auto md:mx-0 text-center md:text-left">
          {/* Logo con acción de ir arriba */}
          <div
            className="flex items-center justify-center md:justify-start gap-2 group cursor-pointer"
            onClick={handleScrollTop}
          >
            {logoSrc ? (
              <img src={logoSrc} alt="Logo REVI" className="h-10 w-auto" />
            ) : (
              <div className="flex items-center gap-2 text-slate-700 !font-black text-2xl uppercase">
                REVI
              </div>
            )}
          </div>
          <p className="text-slate-500 text-sm font-medium leading-relaxed text-center md:text-left">
            {t("footerDesc")}
          </p>
        </div>

        {/* COLUMNA DERECHA: Links */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-12 w-full md:w-auto text-center md:text-left">
          {/* Bloque Recursos */}
          <div className="space-y-4">
            <h4 className="text-xs !font-black uppercase text-slate-700 tracking-widest">
              {t("resTitle")}
            </h4>
            <ul className="text-sm text-slate-500 space-y-3 font-medium text-center md:text-left text-xs">
              <li>
                <a
                  href="/"
                  onClick={handleDeadLink}
                  className="hover:text-sky-500 transition-colors uppercase text-[10px] !font-black no-underline text-slate-500"
                >
                  {t("res1")}
                </a>
              </li>
              <li>
                <a
                  href="/"
                  onClick={handleDeadLink}
                  className="hover:text-sky-500 transition-colors uppercase text-[10px] !font-black no-underline text-slate-500"
                >
                  {t("res2")}
                </a>
              </li>
            </ul>
          </div>

          {/* Bloque Legal */}
          <div className="space-y-4">
            <h4 className="text-xs !font-black uppercase text-slate-700 tracking-widest text-center md:text-left">
              {t("legalTitle")}
            </h4>
            <ul className="text-sm text-slate-500 space-y-3 font-medium text-center md:text-left text-xs">
              <li>
                <a
                  href="/"
                  onClick={handleDeadLink}
                  className="hover:text-sky-500 transition-colors uppercase text-[10px] !font-black no-underline text-slate-500"
                >
                  {t("legal1")}
                </a>
              </li>
              <li>
                <a
                  href="/"
                  onClick={handleDeadLink}
                  className="hover:text-sky-500 transition-colors uppercase text-[10px] !font-black no-underline text-slate-500"
                >
                  {t("legal2")}
                </a>
              </li>
            </ul>
          </div>

          {/* Bloque Empresa */}
          <div className="space-y-4 text-center md:text-left">
            <h4 className="text-xs !font-black uppercase text-slate-700 tracking-widest text-center md:text-left">
              {t("companyTitle")}
            </h4>
            <ul className="text-sm text-slate-500 space-y-3 font-medium text-center md:text-left text-xs">
              <li>
                <a
                  href="/"
                  onClick={handleDeadLink}
                  className="hover:text-sky-500 transition-colors uppercase text-[10px] !font-black no-underline text-slate-500"
                >
                  {t("comp1")}
                </a>
              </li>
              <li>
                <a
                  href="/"
                  onClick={handleDeadLink}
                  className="hover:text-sky-500 transition-colors uppercase text-[10px] !font-black no-underline text-slate-500"
                >
                  {t("comp2")}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* BARRA INFERIOR COPYRIGHT */}
      <div className="max-w-7xl mx-auto pt-12 mt-12 border-t border-slate-200 text-center text-slate-500">
        <p className="text-[10px] !font-black text-slate-400 uppercase tracking-[0.3em] leading-none text-center">
          {t("copyright")}
        </p>
      </div>
    </footer>
  );
}
